import * as React from 'react';
import classNames from 'classnames';
import './styles.scss';

export interface IControlToggleProps {
  /** Controlled value */
  checked: boolean;
  /** Disabled status */
  disabled?: boolean;
  /** Focus handler */
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  /** Blur handler */
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  /** Change handler */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /** DOM target element name attribute */
  name?: string;
  /** DOM target element id attribute */
  id?: string;
  /** className to append */
  className?: string;
}

/**
 * HTML checkbox replacement with extended functionality and styling.
 */
const ControlToggle: React.FunctionComponent<IControlToggleProps> = (props) => {
  return (
    <label className={classNames('control-toggle', props.className)}>
      <input
        type="checkbox"
        checked={props.checked}
        disabled={props.disabled}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onChange={props.onChange}
        name={props.name}
        id={props.name}
      />
      <span className={'control-toggle__inner'}>
        <span className={'control-toggle__knob'} />
      </span>
    </label>
  );
};

ControlToggle.displayName = 'ControlToggle';

export default ControlToggle;
